import { render, staticRenderFns } from "./UnternehmenFilters.vue?vue&type=template&id=54ae7545&scoped=true&"
import script from "./UnternehmenFilters.vue?vue&type=script&lang=ts&"
export * from "./UnternehmenFilters.vue?vue&type=script&lang=ts&"
import style0 from "./UnternehmenFilters.vue?vue&type=style&index=0&id=54ae7545&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae7545",
  null
  
)

export default component.exports